import React from 'react';
import CommonLoading from './components/CommonLoading';

export const defaultLoadableConfig = {
	loading: (props) => {
		if (props.error) {
			console.log(props.error);
		}

		return <CommonLoading spinnerWithDelay />;
	},
};

export const modalLoadableConfig = {
	loading: (props) => {
		if (props.error) {
			console.log(props.error);
		}

		return <CommonLoading noBackground />;
	},
};
